import { useEffect, useState } from 'react';
import ApiHelper from 'utils/apiHelper';
import config from 'config';

// Returns the reCAPTCHA site key. The authoritative value is stored in the
// database and editable by a Root Admin on the Security Settings page; this hook
// fetches it from the server and falls back to the build-time config value
// (REACT_APP_RECAPTCHA_SITE_KEY) if the server hasn't got one set yet.
const useRecaptchaSiteKey = () => {
    const [siteKey, setSiteKey] = useState(config.recaptchaSiteKey || '');

    useEffect(() => {
        let active = true;
        ApiHelper.get('/api/settings/recaptcha_key/')
            .then((res) => {
                if (active && res?.data?.siteKey) {
                    setSiteKey(res.data.siteKey);
                }
            })
            .catch(() => {
                /* keep the config fallback */
            });
        return () => {
            active = false;
        };
    }, []);

    return siteKey;
};

export default useRecaptchaSiteKey;
